<div *ngFor="let roteiro of roteirosCrossdocking" class="border-bottom py-3">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <div class="d-flex align-items-center">
      <i class="bi bi-geo-alt-fill fs-4" [style.color]="'#' + roteiro.corRota"></i>
      <span class="tit-destaque ms-1 me-2" style="font-size: 16px;">{{ roteiro.numeroRoteiroFilho }} </span>
      <span class="sub-tit-destaque">{{roteiro.codigoRota}} ({{roteiro.quantidadeClientes}} clientes) - {{ roteiro.previsaoSaidaVeiculo | date: 'dd/MM/yyyy' }}</span>
    </div>
   
  

  </div>

  <div class="d-flex align-items-center ms-4">
    <div class="d-flex align-items-center me-5">
      <img src="assets/img/icons/tgt_coin.svg" alt="">
      <span class="sub-tit-destaque ms-1">Valor: <span class="tit-destaque">{{ roteiro.valor | currency:'BRL':'symbol'  }}</span></span>
    </div>
    
    <div class="d-flex align-items-center">
      <img src="assets/img/icons/tgt_weight.svg" alt="">
      <span class="sub-tit-destaque ms-1">Peso: <span class="tit-destaque">{{roteiro.peso }}kg ({{roteiro.pesoPercent}}%)</span></span>
    </div>
   
  </div>

  <div class="d-flex justify-content-between align-items-center ms-4 mt-2">
    <div class="d-flex align-items-center">
      <img src="assets/img/icons/tgt_cubic.svg" alt="">
      <span class="sub-tit-destaque ms-1">Cub: <span class="tit-destaque">{{roteiro.cub}}m³ ({{roteiro.cubPercent}}%)</span></span>
    </div>
    <div class="d-flex align-items-center">
      <img src="assets/img/icons/tgt_palett.svg" alt="">
      <span class="sub-tit-destaque ms-1">Paletes: <span class="tit-destaque">{{ roteiro.Paletes }} ({{roteiro.paletesPercent}}%)</span></span>
    </div>
    
    <div class="d-flex align-items-center">
      <img src="assets/img/icons/boxes.svg" alt="">
      <span class="sub-tit-destaque ms-1">Vol: <span class="tit-destaque">{{roteiro.vol}}</span></span>
    </div>
  </div>
</div>
